import React from "react";
import GoBackButtonComponent from "../../../public/goBackButton";

export default function UserResponsiveHeaderComponent({ title }) {
  return (
    <div className="d-xs-block d-md-none">
      <GoBackButtonComponent/>
      <h5 className="text-center">{title}</h5>
    </div>
  );
}
